export default {"src":"/_next/static/media/heart-lightning.132436e2.svg","height":127,"width":166};